export const LIBRARY_OPENING_HOURS = {
    on_weekdays: {
        start: "8:00",
        end: "20:00",
    },
    on_saturday: {
        start: "9:00",
        end: "15:00",
    },
    on_sunday: {
        start: null,
        end: null,
    },
};

export const LIBRARY_PHONE_LIST = [
    "2310891751",
    "2310891752",
    "2310891118",
    "2310891137",
];